// @flow

import * as React from "react";
import type { InputType } from "../../Input/TextInput";

import NumberInput from "../../Input/NumberInput";

type YearPickerProps = {
  input: InputType,
  placeholder: string
};

const YearPicker = ({ input, placeholder }: YearPickerProps) => (
  <NumberInput
    input={input}
    placeholder={placeholder}
    data-testid={`yearInput:${input.name}`}
    sideSymbol={() => <i className="icon-calendar-empty" />}
    separateThousands={false}
  />
);

YearPicker.defaultProps = {
  placeholder: ""
};

export default YearPicker;
